module.exports = __webpack_public_path__ + "static/media/Arrow.3c43d3bf.svg";